import { useIntl } from 'react-intl';

import { Study } from '@/shared/api/protocol-ts/model/dto_study_pb';
import { orderReportName } from '@/shared/i18n';
import {
  openInNewBrowserTab,
  getRawMeshViewerLink,
  getImageSrc,
} from '@/shared/lib';

export const useRawMeshViewerCard = (study: Study) => {
  const { formatMessage } = useIntl();

  const title = formatMessage(orderReportName.RawMeshViewer);

  const uploadDate = study.Created?.At?.toDate();

  const previewSrc = getImageSrc(study.DisplayAssetID, 'preview');

  const handleCardClick = () => {
    openInNewBrowserTab(getRawMeshViewerLink(study.ID));
  };

  return {
    title,
    uploadDate,
    previewSrc,
    handleCardClick,
  };
};
